export default {
  namespaced: true,
  state: {
    footerBar: [],
  },
  mutations: {
    setFooterBar(state, payload) {
      state.footerBar = payload
    },
  }
}
